export default __webpack_public_path__ + "static/media/icon_acc_warn_red.ce40707d.svg";